import DashboardLayout from "@/views/Layout/DashboardLayout.vue";
import Middleware from "@/middleware";

const Dashboard = () =>
    import("@/modules/dashboard/views/Dashboard.vue");
const DashboardDelivredCamp = () =>
    import("@/modules/dashboard/views/DashboardDelivredCamp.vue");
const AssignCampDashboard = () =>
    import("@/modules/dashboard/views/AssignCampDashboard.vue");
const additionsStageDashboard = () => import("@/modules/dashboard/views/AdditionsStageDashboard.vue")
const GisDashboard = () => import("@/modules/dashboard/views/GISDashboard.vue")
const DashboardReportViolations = () => import("@/modules/dashboard/views/DashboardReportViolations.vue")
const CivilDefenseDashboard = () =>
    import("@/modules/dashboard/views/CivilDefenseDashboard.vue");
export const dashboardPage = {

    path: "/",
    name: "DashboardPage",
    component: DashboardLayout,
    children: [

        {
            path: "/dashboard",
            name: "Default",
            component: Dashboard,
            meta: {
                groupName: "Dashboards",
                middlewares: [
                    Middleware.auth,
                    Middleware.permission,
                    Middleware.signeture,
                ],
                permissions: "",
            },
        },
        {
            path: "/delivery-business",
            name: "DashboardDelivredCamp",
            component: DashboardDelivredCamp,
            meta: {
                groupName: "Dashboards",
                middlewares: [
                    Middleware.auth,
                    Middleware.permission,
                    Middleware.signeture,
                ],
                // permissions: "",
                permissions: "dashboard-delivery-business"
            },
        },
        // {
        //     path: "/camp-delivery-performance",
        //     name: "CampDeliveryPerformanceIndex",
        //     component: AssignCampDashboard,
        //     meta: {
        //         groupName: "Dashboards",
        //         middlewares: [
        //             Middleware.auth,
        //             Middleware.permission,
        //             Middleware.signeture,
        //         ],
        //         permissions: "dashboard-delivred-camp",
        //     },
        // },
        {
            path: "/additions-stage",
            name: "additionsStage",
            component: additionsStageDashboard,
            meta: {
                groupName: "Dashboards",
                middlewares: [
                    Middleware.auth,
                    Middleware.permission,
                    Middleware.signeture,
                ],
                permissions: "dashboard-additions-stage",
            },
        },
        {
            path: "/gis-dashboard",
            name: "Gis",
            component: GisDashboard,
            meta: {
                groupName: "Dashboards",
                middlewares: [
                    Middleware.auth,
                    Middleware.permission,
                    Middleware.signeture,
                ],
                permissions: "dashboard-gis-1",
            },
        },
        {
            path: "/civil-defense",
            name: "DashboardCivilDefense",
            component: CivilDefenseDashboard,
            meta: {
                groupName: "Dashboards",
                middlewares: [
                    Middleware.auth,
                    Middleware.permission,
                    Middleware.signeture,
                ],
                permissions: "dashboard-civil-defense",
            },
        },
        {
            path: "/dashboard-report-violations",
            name: "DashboardViolations",
            component: DashboardReportViolations,
            meta: {
                groupName: "Dashboards",
                middlewares: [
                    Middleware.auth,
                    Middleware.permission,
                    Middleware.signeture,
                ],
                permissions: "dashboard-report-violations",
            },
        },
    ]

}